// extracted by mini-css-extract-plugin
export var backupIcon = "_se-1";
export var image = "_se-0";